import { render, staticRenderFns } from "./AnswerJauge.vue?vue&type=template&id=9237a952&"
import script from "./AnswerJauge.vue?vue&type=script&lang=js&"
export * from "./AnswerJauge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports